<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App',
		mounted() {
			this.$store.commit("login")
		}
	}
</script>

<style lang="less">
	* {
		margin: 0;
		padding: 0;
		border: 0;
	}

	* ::-webkit-scrollbar {
		// width: 0 !important;
		// height: 0 !important;
	}
	#app {
		min-width: 1600px;
	}
	
	.pc-width {
		width: 1200px;
		margin: 0 auto;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue